<div style="width: 100%" class="row-base div-between">
  <h2 mat-dialog-title>NC Proveedor OS {{ codigo ?? "" }}</h2>
  <button
    mat-icon-button
    color="primary"
    *ngIf="id"
    (click)="openDialogDelete()"
  >
    <i-tabler name="trash" class="icon-18"></i-tabler>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <div
    *ngIf="loading || isGetMultimediaLoading"
    class="div-center"
    style="height: 200px"
  >
    <mat-spinner></mat-spinner>
  </div>
  <div
    [ngStyle]="{
      display: !loading && !isGetMultimediaLoading ? 'block' : 'none'
    }"
  >
    <div *ngIf="!ErrorFetch" class="div-center column-base">
      <app-upload-files
        [numberOS]="numberOS"
        (isloadingGet)="onFinishLoading($event)"
        (isloadingMutations)="onFinishLoadingMutations($event)"
        [confirmGuardar]="confirmGuardar"
        [confirmAllDelete]="confirmAllDelete"
      ></app-upload-files>

      <form
        [formGroup]="myForm"
        (ngSubmit)="submitForm()"
        #contactForm="ngForm"
        style="
          border-radius: 12px;
          border: 1px solid rgb(255, 255, 255);
          width: 100%;
        "
        class="center-div column-base"
      >
        <div class="row-base" style="width: 100%">
          <div class="container-column col-lg-6">
            <mat-label class="label">Reembolso en Efectivo (REEF)</mat-label>
            <mat-form-field
              appearance="outline"
              class="w-100 miBigInput"
              color="primary"
            >
              <input
                matInput
                type="text"
                id="reef"
                name="reef"
                formControlName="reef"
                (input)="onNumberInput($event)"
                required
              />
            </mat-form-field>
          </div>

          <div class="container-column col-lg-6">
            <mat-label class="label">SAF</mat-label>
            <mat-form-field
              appearance="outline"
              class="w-100 miBigInput"
              color="primary"
            >
              <input
                matInput
                type="text"
                id="saf"
                name="saf"
                formControlName="saf"
                (input)="onNumberInput($event)"
                required
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row-base" style="width: 100%">
          <div class="container-column col-lg-6">
            <mat-label class="label">Pago Parcial</mat-label>
            <mat-form-field
              appearance="outline"
              class="w-100 miBigInput"
              color="primary"
            >
              <input
                matInput
                type="text"
                id="partialPayment"
                name="partialPayment"
                formControlName="penalidad"
                (input)="onNumberInput($event)"
                required
              />
            </mat-form-field>
          </div>

          <div class="container-column col-lg-6">
            <mat-label class="label">Penalidad</mat-label>
            <mat-form-field
              appearance="outline"
              class="w-100 miBigInput"
              color="primary"
            >
              <input
                matInput
                type="text"
                id="penalidad"
                name="penalidad"
                formControlName="partialPayment"
                (input)="onNumberInput($event)"
                required
              />
            </mat-form-field>
          </div>
        </div>

        <div
          mat-dialog-actions
          class="div-center row-base"
          style="width: 100%; gap: 8px; margin-top: 20px"
        >
          <button
            class="buttonPrimary"
            type="submit"
            [disabled]="!contactForm.valid"
          >
            <div
              *ngIf="loadingSubmit"
              style="width: 100%"
              class="div-center row-base white-spinner"
            >
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            <div *ngIf="!loadingSubmit">Guardar</div>
          </button>
          <button
            *ngIf="!loadingSubmit"
            class="buttonSecundary"
            mat-dialog-close
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>

    <div *ngIf="ErrorFetch" class="div-center column-base">
      <h3>Error al cargar la Nota de Crédito del Proveedor</h3>
      <p>{{ ErrorFetch }}</p>
      <div style="height: 20px"></div>
      <button class="buttonPrimary" mat-dialog-close>Cerrar</button>
    </div>
  </div>
</mat-dialog-content>
